import { NgModule } from '@angular/core';

import { EditalService } from './edital.service';
import { EnderecoService } from './endereco.service';
import { FormDataService } from './api/form-data.service';
import { ItemEditalService } from './item-edital.service';
import { ListaService } from './lista.service';
import { PessoaService } from './pessoa.service';
import { InscricaoService } from './inscricao.service';
import { LocalStorageService } from './api/local-storage.service';
import { ConvocacaoService } from './convocacao.service';
import { ConvocacaoDeficienteService } from './convocacao-deficiente.service';
import { AvaliacaoService } from './avaliacao.service';
import { AvaliacaoDeficienteService } from './avaliacao-deficiente.service';
import { ServidorService } from './servidor.service';
import { PublicacaoService } from './publicacao.service';
import { RouteNavigationService } from './api/route-navigation.service';
import { RouteDataService } from './api/route-data.service';
import { AccountService } from './account.service';

@NgModule({
  providers: [
    EditalService,
    EnderecoService,
    FormDataService,
    LocalStorageService,
    RouteNavigationService,
    ItemEditalService,
    ListaService,
    AccountService,
    PessoaService,
    InscricaoService,
    ConvocacaoService,
    ConvocacaoDeficienteService,
    AvaliacaoService,
    AvaliacaoDeficienteService,
    ServidorService,
    PublicacaoService,
    RouteDataService
  ],
})
export class ServicesModule { }



// WEBPACK FOOTER //
// ./src/app/services/services.module.ts